import * as React from 'react'
import { NextPageContext } from 'next'
import Layout from './index'

export type AppProp = {
  title: string
  logo?: string
  bg?: string
}
type CustomPage<P = Record<string, unknown>> = React.ComponentType<{ pageProps: { [key: string]: any } }> & {
  getLayout?: (page: JSX.Element, props: { [key: string]: any }) => JSX.Element
  getInitialProps?: (context: NextPageContext) => Promise<P>
}
const WrapPage = (page: CustomPage, opt: AppProp): CustomPage => {
  page.getLayout = (page, props) => <Layout appOpt={{ ...opt, ...props }}>{page}</Layout>
  return page
}

export default WrapPage
